<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.create_user_realname}}_外协招工申请</template>

			<template #info>
				<c-field>{{baseInfo.customer_name}}</c-field>
				<c-field label="单据编号">{{baseInfo.recruit_number}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="关联工单"><c-link @click="mp.navigateWeb('/aftersales/work/detail', {id: baseInfo.order_id})">{{baseInfo.order_number}}</c-link></c-field>
			<c-field label="招工类型"><c-state dict="recruitTypeDic" :value="baseInfo.recruit_type"></c-state></c-field>
			<c-field label="招工人数">{{baseInfo.recruit_count}}人</c-field>
			<c-field label="上班天数">{{baseInfo.work_days}}天</c-field>
			<c-field label="所需费用"><b style="font-size: .32rem; color: #f00;">￥{{baseInfo.required_fee}}</b></c-field>
			<c-field label="人员到岗时间">{{baseInfo.arrival_time}}</c-field>
			<c-field label="备注">{{baseInfo.remark}}</c-field>
		</doc-content>

		<doc-log ref="docLog" :form-id="baseInfo.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			flow="2"
			:order="id"
			:status="baseInfo.status"
			:applicant="baseInfo.is_founder == 1"
			:approver="baseInfo.is_approval == 1"
			@edit="mp.navigateWeb('/aftersales/outsource/edit', {id: baseInfo.id})"
			@delete="deleteHandle"
			@update="update"
		></doc-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/outsource/recruit/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, transaction}) => {
						this.baseInfo = detailInfo;
						this.$refs.docHandle.init(transaction);
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/outsource/recruit/remove',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>